import React, { useEffect } from 'react';
import {connect, useSelector} from "react-redux";

// components
import UserList from "./_list";
import {showLoader} from "../../../components/loader/loader";

// actions
import {getStateByPath} from "../../../redux/selectors";
import {ADD_STATE, REMOVE_STATE} from "../../../redux/actions/generics/IndexedActions";

function User(props) {
    const path = props.path || 'security/user';
    const componentState = useSelector(state => getStateByPath(state, path));
    const { loading } = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    return (
        <>
            {loading && showLoader()}
            { componentState && <UserList path={path} /> }
        </>
    );
}

const mapStateToProps = _ => ({
});

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
});

export default connect(mapStateToProps, mapActionsToProps)(User)